<template>
  <qx-card-form title="服务商信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="address" slot-scope="prop">
        <ChooseAddressMap v-model="prop.form.address" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  servicerDetail,
  servicerSelectList,
} from 'api/service';
export default {
  data () {
    return {
      otherFormData: {
        serviceType: '', // 服务商类型
      },
      baseForm: {
        serviceUserIdOptions: [], // 服务商
        form: [
          {
            label: '服务商',
            value: 'serviceUserId',
            type: 'select',
            // disabled: true,
            onChange: () => {
              this.handleServicerChange();
            },
          },
          {
            label: '手机账号',
            value: 'loginAcct',
            type: 'input',
            disabled: true,
          },
          {
            label: '公司名称',
            value: 'serviceName',
            type: 'input',
            disabled: true,
          },
          {
            label: '联系人',
            value: 'linkman',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          serviceUserId: [ // 服务商
            { required: true, message: '请选择服务商', trigger: 'blur' },
          ],
          loginAcct: [ // 手机账号
            { required: true, message: '请输入手机账号', trigger: 'blur' },
          ],
          serviceName: [ // 公司名称
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          linkman: [ // 联系人
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async handleServicerChange () {
      const serviceUserId = this.$refs.baseForm.getVal('serviceUserId');
      if (serviceUserId) {
        const serverRes = await servicerDetail({
          serviceUserId,
        });
        this.$refs.baseForm.setVal('loginAcct', serverRes.serviceData.loginAcct); // 手机账号
        this.$refs.baseForm.setVal('serviceName', serverRes.serviceData.serviceName); // 公司名称
        this.$refs.baseForm.setVal('linkman', serverRes.serviceData.linkman === '' ? serverRes.serviceData.loginAcct : serverRes.serviceData.linkman); // 联系人
        this.otherFormData.serviceType = serverRes.serviceData.serviceType; // 服务商类型
      } else {
        this.$refs.baseForm.setVal('loginAcct', ''); // 手机账号
        this.$refs.baseForm.setVal('serviceName', ''); // 公司名称
        this.$refs.baseForm.setVal('linkman', ''); // 联系人
      }
      this.$emit('getOtherFormVal', {
        from: 'baseForm',
        tar: 'merchant',
      });
    },
    async getList () {
      const resServiceUserId = await servicerSelectList();
      this.baseForm.serviceUserIdOptions = [...resServiceUserId];
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      res.serviceType = this.otherFormData.serviceType;
      return res;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.serviceType = this.otherFormData.serviceType;
      }
      return formData;
    },
    async init (data = {}) {
      if (data.serviceUserId && this.$route.query.serviceUserId) {
        data.serviceUserId = Number(this.$route.query.serviceUserId);
      }
      this.$refs.baseForm.setVal('serviceUserId', data.serviceUserId);
      await this.handleServicerChange();
      // this.setFormAttrVal({
      //   form: this.baseForm,
      //   attr: 'disabled',
      //   value: Boolean(this.$route.query.id),
      //   names: ['serviceUserId'],
      // });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
